var image_upload_default = {
  "container": "yf7zj",
  "disabled": "E59MH",
  "imageInput": "_8BvKd",
  "overlay": "HO11Z",
  "text": "eArJD",
  "shown": "ChLEu",
  "hide": "D5OhI",
  "spinner": "y67Tw",
  "spin": "PVkse"
};
export {
  image_upload_default as default
};
//# sourceMappingURL=image-upload-scss.js.map
